/**
 * PDP React editor bridge (Select 3D + Sublime Subli Color):
 * - login gate before opening the React editor
 * - mark Upload-Lift file ready after Continuer
 * - keep Print.App "éditeur 1.0" tab mapping without loading Sherpa 2.0
 */
(function () {
  'use strict';

  if (window.__pdpSelect3dEditorReady) return;
  window.__pdpSelect3dEditorReady = true;

  function setStatus(root, message, tone) {
    var status = root.querySelector('[data-select3d-order-status]');
    if (!status) return;
    status.hidden = !message;
    status.textContent = message || '';
    status.classList.remove('is-error', 'is-success');
    if (tone) status.classList.add(tone);
  }

  function resetUploadLiftBox(el) {
    if (!el) return;
    el.style.opacity = '';
    el.style.pointerEvents = '';
    el.style.overflow = '';
    el.style.width = '';
    el.style.height = '';
    el.style.top = '';
    el.style.position = 'relative';
    el.style.left = 'unset';
  }

  function warmUploadLift() {
    /* Keep the existing Upload Lift box in place — do not move or hide page blocks. */
  }

  function revealOrderSection() {
    if (typeof window.__sherpaRevealPdpOrderSection === 'function') {
      window.__sherpaRevealPdpOrderSection();
    } else {
      var opener = document.querySelector('.js--show--hidden-elements');
      if (opener) opener.classList.add('visually-hidden');
      [
        '.shopacado--table__container',
        '#countdown-timer',
        '.upload-lift',
        '.product-form',
        'pickup-availability',
        '.tooltip',
        '[is-app-handler]',
      ].forEach(function (selector) {
        var node = document.querySelector(selector);
        if (!node) return;
        node.style.position = 'relative';
        node.style.left = 'unset';
      });
      document.querySelectorAll('.js-hide-after-click').forEach(function (node) {
        node.classList.add('visuallyhidden');
      });
    }
    resetUploadLiftBox(document.querySelector('.upload-lift'));
  }

  function markFileReady(root, filename, filenames) {
    root.dataset.sherpaFileReady = 'true';
    var launchBtn = root.querySelector('[data-select3d-order-launch]');
    if (launchBtn) {
      launchBtn.textContent = 'Rouvrir l’éditeur';
    }
    var names =
      Array.isArray(filenames) && filenames.length
        ? filenames.join(' + ')
        : filename;
    setStatus(
      root,
      (names ? 'Fichiers prêts : ' + names + '. ' : 'Fichiers prêts. ') +
        'Finalisez vos options puis ajoutez au panier.',
      'is-success'
    );
  }

  /* --- Écusson size ---------------------------------------------------------
   * The editor owns the size: it grows the plate for the 2 mm contour and for a
   * Rond / Carré fond, so the price must follow it rather than a typed guess.
   * These fields go read-only once the editor has spoken, otherwise a customer
   * could shrink them afterwards and pay for a smaller écusson than the one the
   * production PDF has us cut. Limits mirror the template's own validator.
   */
  var SIZE_MIN_CM = 2;
  var SIZE_MAX_CM = 25;
  var SURFACE_MAX_CM2 = 625;

  function sizeInputs() {
    var width = document.getElementById('s_width');
    var height = document.getElementById('s_height');
    return width && height ? { width: width, height: height } : null;
  }

  function sizeNote(inputs) {
    var box = inputs.width.closest('.sherpa-custom-box') || inputs.width.parentNode;
    var note = box.querySelector('[data-select3d-size-note]');
    if (!note) {
      note = document.createElement('div');
      note.setAttribute('data-select3d-size-note', '');
      /* `sherpa-info-bar` borrows the block's own look. Never `error-msg`: that
         class carries `display: none` and the note would vanish. */
      note.className = 'sherpa-info-bar';
      box.appendChild(note);
    }
    return note;
  }

  function sizeIssue(w, h) {
    if (w > SIZE_MAX_CM || h > SIZE_MAX_CM) {
      return 'Cet écusson dépasse ' + SIZE_MAX_CM + ' cm de côté.';
    }
    if (w < SIZE_MIN_CM || h < SIZE_MIN_CM) {
      return 'Cet écusson fait moins de ' + SIZE_MIN_CM + ' cm de côté.';
    }
    if (w * h > SURFACE_MAX_CM2) {
      return 'Cet écusson dépasse ' + SURFACE_MAX_CM2 + ' cm² de surface.';
    }
    return '';
  }

  /*
   * The template's validator means to block add-to-cart on an unorderable size,
   * but its `[name="add"]` lookup runs while the size block is still ahead of the
   * buy buttons in the DOM, so it captured null and never disabled anything —
   * measured on the page, disabled stayed false even on a fresh load. The editor
   * can now fill these fields on its own, so guard the button here. Only ever
   * re-enable a button we disabled ourselves: a sold-out variant must stay locked.
   */
  var sizeIssueNow = '';
  var guardWatching = false;

  function guardAddToCart() {
    document.querySelectorAll('[name="add"]').forEach(function (btn) {
      var ours = btn.dataset.select3dSizeBlocked === 'true';
      if (sizeIssueNow) {
        /* A button already disabled by the theme (sold out, unavailable variant)
           is left alone, and never re-enabled by us. */
        if (!ours && btn.disabled) return;
        /* Idempotent on purpose: assigning an unchanged value would feed the
           observer below its own mutations. */
        if (!ours) btn.dataset.select3dSizeBlocked = 'true';
        if (!btn.disabled) btn.disabled = true;
        if (btn.style.opacity !== '0.5') btn.style.opacity = '0.5';
      } else if (ours) {
        delete btn.dataset.select3dSizeBlocked;
        if (btn.disabled) btn.disabled = false;
        if (btn.style.opacity) btn.style.opacity = '';
      }
    });
  }

  /*
   * A valid size makes the theme re-render the buy buttons, and that render lands
   * whenever the network says so. Re-asserting on a timer lost that race: fixed
   * delays fired *before* the fresh, enabled button arrived, so an unorderable
   * size stayed purchasable. Watch the DOM instead and re-assert on every change.
   * `childList` catches the button being replaced, `disabled` catches it being
   * re-enabled in place; the guard above is idempotent, so this cannot loop.
   */
  function watchAddToCart() {
    if (guardWatching || typeof MutationObserver !== 'function') return;
    guardWatching = true;
    new MutationObserver(reassertOnRerender).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled'],
    });
  }

  /* A variant change re-renders the buy buttons, which can take both the button
     state and the order-mode input — or just its form binding — with them. Both
     are re-asserted from the same observer; each call is idempotent, so it
     settles instead of feeding itself new mutations. */
  function reassertOnRerender() {
    guardAddToCart();
    if (orderedWithEditor) markOrderedWithEditor();
  }

  function guardAddToCartFor(issue) {
    sizeIssueNow = issue;
    guardAddToCart();
    watchAddToCart();
  }

  function applyEditorSize(detail) {
    var inputs = sizeInputs();
    if (!inputs) return;
    var w = Number(detail && detail.widthCm);
    var h = Number(detail && detail.heightCm);
    if (!isFinite(w) || !isFinite(h) || w <= 0 || h <= 0) return;

    [[inputs.width, w], [inputs.height, h]].forEach(function (pair) {
      var input = pair[0];
      input.value = String(pair[1]);
      input.readOnly = true;
      input.setAttribute('aria-readonly', 'true');
      input.style.cursor = 'not-allowed';
      /* The template's validator listens for `input`: it recomputes the surface,
         picks the format tier and selects the variant that carries the price. */
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    var issue = sizeIssue(w, h);
    guardAddToCartFor(issue);
    var note = sizeNote(inputs);
    note.style.color = issue ? '#d93025' : '';
    note.style.background = issue ? '#fff0f0' : '';
    note.style.borderLeftColor = issue ? '#d93025' : '';
    note.style.fontWeight = issue ? 'bold' : '';
    note.textContent = issue
      ? issue + ' Reprenez l’éditeur 3D pour le redimensionner.'
      : 'Taille calculée par l’éditeur 3D d’après votre logo, contour de 2 mm compris (' +
        w.toFixed(1) +
        ' × ' +
        h.toFixed(1) +
        ' cm). Pour la changer, rouvrez l’éditeur.';
  }

  function onEditorSize(event) {
    applyEditorSize((event && event.detail) || event || {});
  }

  window.__pdpSelect3dOnSize = function (detail) {
    applyEditorSize(detail || {});
  };

  function setAppMode(root, mode) {
    var input = root.querySelector('input[data-app-mode-value="' + mode + '"]');
    root.dataset.appMode = mode;
    if (!input) return;
    input.checked = true;
    root.querySelectorAll('input[data-app-mode-value]').forEach(function (other) {
      if (other !== input) other.checked = false;
    });
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function getHandlerRoot() {
    return (
      document.querySelector('[data-select3d-pdp][is-app-handler]') ||
      document.querySelector('[is-app-handler]')
    );
  }

  function openEditor() {
    if (typeof window.Select3D_openEditor === 'function') {
      window.Select3D_openEditor();
      return;
    }
    window.dispatchEvent(new CustomEvent('select3d:open-editor'));
  }

  function launchEditor(root) {
    if (root.dataset.customerLoggedIn !== 'true') {
      var returnToPdp = new URL(window.location.href);
      returnToPdp.searchParams.set('select3d_open', '1');
      var loginUrl = new URL(root.dataset.loginUrl || '/account/login', window.location.origin);
      loginUrl.searchParams.set('return_url', returnToPdp.pathname + returnToPdp.search + returnToPdp.hash);
      window.location.href = loginUrl.toString();
      return;
    }
    revealOrderSection();
    setAppMode(root, 'editor2');
    openEditor();
  }

  function hasPrintAppCreateMapping() {
    var container = document.querySelector('#pa-buttons');
    if (!container) return false;
    return !!container.querySelector(
      'button, a, [role="button"], input[type="button"], input[type="submit"]'
    );
  }

  function setCreateTabVisible(root, visible) {
    var tab = root.querySelector('[data-app-handler-create-tab]');
    if (!tab) return;
    if (visible) {
      tab.hidden = false;
      root.classList.remove('app_handler--no-create');
      root.dataset.createMapped = 'true';
      return;
    }
    tab.hidden = true;
    root.classList.add('app_handler--no-create');
    root.dataset.createMapped = 'false';
    var createInput = tab.querySelector('input[data-app-mode-value="create"]');
    if (createInput && createInput.checked) {
      setAppMode(root, 'import');
    }
  }

  function watchCreateTabMapping(root) {
    if (root.__pdpSelect3dCreateWatch) return;
    root.__pdpSelect3dCreateWatch = true;
    setCreateTabVisible(root, false);
    var settled = false;
    function apply() {
      var mapped = hasPrintAppCreateMapping();
      if (mapped) {
        settled = true;
        setCreateTabVisible(root, true);
        return true;
      }
      return false;
    }
    if (apply()) return;
    var observer = new MutationObserver(function () {
      if (apply() && observer) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      if (apply() || attempts >= 20) {
        clearInterval(timer);
        if (!settled) setCreateTabVisible(root, false);
        observer.disconnect();
      }
    }, 250);
  }

  function stripOpenQuery() {
    try {
      var url = new URL(window.location.href);
      if (!url.searchParams.has('select3d_open')) return;
      url.searchParams.delete('select3d_open');
      window.history.replaceState({}, '', url.pathname + url.search + url.hash);
    } catch (err) {
      /* ignore */
    }
  }

  function bindRoot(root) {
    if (root.__pdpSelect3dBound) return;
    root.__pdpSelect3dBound = true;
    root.querySelectorAll('input[data-app-mode-value]').forEach(function (input) {
      input.addEventListener('change', function () {
        if (input.checked) root.dataset.appMode = input.getAttribute('data-app-mode-value') || '';
      });
    });

    var launchBtn = root.querySelector('[data-select3d-order-launch]');
    if (launchBtn) {
      launchBtn.addEventListener('click', function (event) {
        event.preventDefault();
        launchEditor(root);
      });
    }

    try {
      if (new URLSearchParams(window.location.search).get('select3d_open') === '1') {
        stripOpenQuery();
        revealOrderSection();
        if (root.dataset.customerLoggedIn === 'true') {
          setAppMode(root, 'editor2');
          openEditor();
        }
      }
    } catch (err) {
      /* ignore */
    }
  }

  /* --- Mode de commande -----------------------------------------------------
   * Both tabs of this PDP end up posting a file through Upload Lift, so neither
   * the cart nor the atelier can tell an editor order from an « Importer un
   * fichier » order by looking at the attachments alone. Stamp the line so they
   * can. `Mode de commande` is the store's existing key for this — Fast Order
   * writes « ⚡ Fast Order » and Forfait Fast Order « ⚡ Forfait Fast Order » —
   * so the value is a human label, not a token, and it shows up verbatim in the
   * cart: `cart-property-label.liquid` has no case for the key and its generic
   * branch prints the key as written. The readers of that key (cart.js,
   * easy-order-capacities.js) only ever test for « forfait fast order », so this
   * value stays inert for them.
   */
  var orderedWithEditor = false;
  var ORDER_MODE_NAME = 'properties[Mode de commande]';
  var ORDER_MODE_VALUE = 'Éditeur 3D';

  function addToCartForm() {
    /* The size inputs sit outside the <form> and join it through their `form`
       attribute, so `s_width.form` *is* the form Shopify will serialise. Ask the
       DOM rather than rebuilding 'product-form-' + section.id: this asset has no
       access to section.id, and the sticky bar and quick view render a second
       product section, so any id hardcoded here would eventually be the wrong one. */
    var width = document.getElementById('s_width');
    if (width && width.form) return width.form;
    return document.querySelector('form[action*="/cart/add"]');
  }

  function markOrderedWithEditor() {
    orderedWithEditor = true;
    watchAddToCart();
    var form = addToCartForm();
    if (!form) return;
    var input = document.querySelector('input[data-select3d-order-mode]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.setAttribute('data-select3d-order-mode', '');
      input.name = ORDER_MODE_NAME;
      /* Park it beside the other out-of-form inputs rather than inside the form:
         a variant change re-renders the buy buttons, and anything living in the
         form would go with them. The `form` attribute re-binds it from wherever
         it sits, and the browser re-resolves that binding after each re-render. */
      /* Inherit the size fields' own binding rather than deriving one from
         `form.id`: those fields demonstrably reach the cart, while the theme
         renders a second product section (sticky bar, quick view) whose form
         carries the same id, so `getElementById(form.id)` can bind us to the
         wrong one and leave the input serialised nowhere. */
      var sizeField = document.getElementById('s_width');
      var formAttr = sizeField && sizeField.getAttribute('form');
      if (formAttr) input.setAttribute('form', formAttr);
      else if (form.id) input.setAttribute('form', form.id);
      var anchor = document.getElementById('s_surface_hidden');
      if (anchor && anchor.parentNode) {
        anchor.parentNode.insertBefore(input, anchor.nextSibling);
      } else {
        document.body.appendChild(input);
      }
    }
    input.value = ORDER_MODE_VALUE;
    /* `input.form` is the association the browser serialises. A `form` attribute
       beats containment, so a stale one must go first: moving the input into the
       form while it still points elsewhere would leave it owned by nothing. */
    if (input.form !== form) {
      if (input.hasAttribute('form')) input.removeAttribute('form');
      if (input.parentNode !== form) form.appendChild(input);
    }
  }

  function onOrderReady(event) {
    var root = getHandlerRoot();
    if (!root) return;
    revealOrderSection();
    var detail = (event && event.detail) || event || {};
    var filename = detail.filename || '';
    /* Belt and braces: the payload repeats the size, so the fields are right at
       the moment the customer adds to cart even if a `select3d:size` was missed. */
    applyEditorSize(detail);
    /* Only here, never on `select3d:open-editor` or on an import inside the
       editor: this event is the editor announcing the production PDF is uploaded.
       A customer who opens the editor, changes their mind and uploads their own
       file is placing a plain upload order and must stay unmarked. */
    markOrderedWithEditor();
    markFileReady(root, filename, detail.filenames);
    setAppMode(root, 'import');
    var uploadBox = document.querySelector('.upload-lift');
    resetUploadLiftBox(uploadBox);
    requestAnimationFrame(function () {
      (uploadBox || root).scrollIntoView({ block: 'center', behavior: 'smooth' });
    });
  }

  window.__pdpSelect3dOnOrderReady = function (detail) {
    onOrderReady({ detail: detail || {} });
  };

  function boot() {
    document.querySelectorAll('[is-app-handler]').forEach(bindRoot);
    window.addEventListener('select3d:order-ready', onOrderReady);
    document.addEventListener('select3d:order-ready', onOrderReady);
    window.addEventListener('select3d:size', onEditorSize);
    document.addEventListener('select3d:size', onEditorSize);
    ['upload:ready', 'uploadlift:ready', 'upload-lift:ready'].forEach(function (name) {
      window.addEventListener(name, function (event) {
        if (event && event.detail) window.__lnUploadField = event.detail;
      });
    });
    warmUploadLift();
    setTimeout(warmUploadLift, 500);
    setTimeout(warmUploadLift, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
